/**
 * Instruction code for how medication should be administered.
 *
 * Stored in `MedicationRequest.dosageInstruction.additionalInstruction`
 *
 * Represents an administration instruction. Fhir also make an allowances for preparation
 * instructions which are not handled by this enum
 *
 */
export enum MedicationRequestDosageInstructionAdministrationCode {
  Oral = 'medicationrequest.dosageinstruction.additionalinstruction.administration.oral',
  Sublingual = 'medicationrequest.dosageinstruction.additionalinstruction.administration.sublingual',
  Buccal = 'medicationrequest.dosageinstruction.additionalinstruction.administration.buccal',
  Rectal = 'medicationrequest.dosageinstruction.additionalinstruction.administration.rectal',
  Intravenous = 'medicationrequest.dosageinstruction.additionalinstruction.administration.intravenous',
  Intramuscular = 'medicationrequest.dosageinstruction.additionalinstruction.administration.intramuscular',
  Subcutaneous = 'medicationrequest.dosageinstruction.additionalinstruction.administration.subcutaneous',
  Intranasal = 'medicationrequest.dosageinstruction.additionalinstruction.administration.intranasal',
  Inhalation = 'medicationrequest.dosageinstruction.additionalinstruction.administration.inhalation',
  Vaginal = 'medicationrequest.dosageinstruction.additionalinstruction.administration.vaginal',
  Transdermal = 'medicationrequest.dosageinstruction.additionalinstruction.administration.transdermal',
  Topical = 'medicationrequest.dosageinstruction.additionalinstruction.administration.topical',
}

export enum MedicationType {
  acute = 'medication.type.acute',
  chronic = 'medication.type.chronic',
}

export const MedicationTypeValue: Record<string, MedicationType> = {
  'medication.type.acute': MedicationType.acute,
  'medication.type.chronic': MedicationType.chronic,
};

export const MedicationTypeDisplay: Record<MedicationType, string> = {
  [MedicationType.acute]: 'Acute',
  [MedicationType.chronic]: 'Chronic',
};
